export const PROJECT_DATA = [
  {
    id: "codedocs",
    name: "CodeDocs",
    type: "Desktop App",
    summary:
      "A real-time collaborative coding platform with support for four programming languages. Allows users to simultaneously code on an interactive editor with fetaures like syntax highlighting, code-autocomplete, multiple cursors and more. Users can communcate through audio or public/private chat while editing.",
    link: "https://github.com/harshh3010/CodeDocs",
    tech: [
      { id: "java", name: "Java" },
      { id: "mysql", name: "MySQL" },
      { id: "scenebuilder", name: "Scene Builder" },
    ],
  },
  {
    id: "hungryyy",
    name: "Hungryyy",
    type: "Android/IOS App",
    summary:
      "Hungryyy is a beautifully designed food delivery application for mobile devices. It allows users to view all the registered restaurants depending on their location. Users can search for their favourite dishes and restaurants, and also explore new items using custom filters. Once they are ready with the cart, they can choose from various modes of payment and avail discounts as per their convenience. The curious ones can then track the food till it arrives and then enjoy their meal 😋.",
    link: "https://github.com/harshh3010/Hungryyy",
    tech: [
      { id: "flutter", name: "Flutter" },
      { id: "mysql", name: "MySQL" },
      { id: "php", name: "PHP" },
      { id: "firebase", name: "Firebase" },
      { id: "nodejs", name: "NodeJS" },
      { id: "googlecloud", name: "Google Cloud" },
    ],
  },
  {
    id: "ampify",
    name: "Ampify",
    type: "Desktop App",
    summary:
      "Work from home with a broken music system made life too stressful for our team. So to stay entertained during the tough times we decided to make one ourselves using JavaFX. Ampify is a media player system with a great UI and packed with many cool features.",
    link: "https://github.com/harshh3010/Ampify",
    tech: [
      { id: "java", name: "Java" },
      { id: "mysql", name: "MySQL" },
      { id: "scenebuilder", name: "Scene Builder" },
    ],
  },
  {
    id: "memennit",
    name: "MemeNNIT",
    type: "Android App",
    summary:
      "MemeNNIT is an app for people who love sharing and making memes. A memennit user can upload his own memes and view memes uploaded by other users, the users are rewarded points on the basis of frequency with which they upload memes and the number of upvotes they receive on their uploads. These points are then used for computing the user's rank and generating a leaderboard listing all the users.",
    link: "https://github.com/harshh3010/MemeNNIT",
    tech: [
      { id: "java", name: "Java" },
      { id: "firebase", name: "Firebase" },
      { id: "nodejs", name: "NodeJS" },
    ],
  },
];
